import React from "react";

const Package = () => {
    return (

        <div className="packages">
            <div className="container">
                <div className="packages-card">
                    <h5 className="mx-auto d-block text-center mb-70">Flexible Plans for Every Seller</h5>

                    <div className="row justify-content-between">

                        <div className=" col-12 col-md-6 col-lg-3 px-20 mb-20">
                            <div className="packages-item-card">
                                <h6 className="text-center">Basic</h6>
                                <hr></hr>
                                <div className="prices discounted">
                                    <div className="original-price">
                                        <div className="main-price-element w-fit-content mx-auto">
                                            15.00
                                        </div>
                                    </div>
                                    <div className="discounted-price">
                                        <div className="main-price-element w-fit-content mx-auto">
                                            5.00
                                        </div>
                                    </div>
                                </div>
                                <button href="/become-seller" className="selectpackage-btn">Select Plan</button>
                                <ul className="icon-list">
                                    <li>
                                        Lorem ipsum dolor
                                    </li>
                                    <li>
                                        Lorem ipsum dolor
                                    </li>
                                    <li>
                                        Lorem ipsum dolor
                                    </li>
                                    <li>
                                        Lorem ipsum dolor
                                    </li>
                                    <li>
                                        Lorem ipsum dolor
                                    </li>
                                    <li>
                                        Lorem ipsum dolor
                                    </li>
                                    <li>
                                        Lorem ipsum dolor
                                    </li>
                                </ul>
                            </div>

                        </div>

                        <div className=" col-12 col-md-6 col-lg-3 px-20  mb-20">
                            <div className="packages-item-card">
                                <h6 className="text-center">Economy</h6>
                                <hr></hr>
                                <div className="prices discounted">
                                    <div className="original-price">
                                        <div className="main-price-element w-fit-content mx-auto">
                                            21.00
                                        </div>
                                    </div>
                                    <div className="discounted-price">
                                        <div className="main-price-element w-fit-content mx-auto">
                                            10.00
                                        </div>
                                    </div>
                                </div>
                                <button href="/become-seller" className="selectpackage-btn">Select Plan</button>
                                <ul className="icon-list">
                                    <li>
                                        Lorem ipsum dolor
                                    </li>
                                    <li>
                                        Lorem ipsum dolor
                                    </li>
                                    <li>
                                        Lorem ipsum dolor
                                    </li>
                                    <li>
                                        Lorem ipsum dolor
                                    </li>
                                    <li>
                                        Lorem ipsum dolor
                                    </li>
                                    <li>
                                        Lorem ipsum dolor
                                    </li>
                                    <li>
                                        Lorem ipsum dolor
                                    </li>
                                    <li>
                                        Lorem ipsum dolor
                                    </li>
                                </ul>
                            </div>

                        </div>

                        <div className=" col-12 col-md-6 px-20 col-lg-3  mb-20">
                            <div className="packages-item-card bestselect">
                                
                                <h6 className="text-center">Business</h6>
                                <hr></hr>
                                <div className="prices discounted">
                                    <div className="original-price">
                                        <div className="main-price-element w-fit-content mx-auto">
                                            15.00
                                        </div>
                                    </div>
                                    <div className="discounted-price">
                                        <div className="main-price-element w-fit-content mx-auto">
                                            5.00
                                        </div>
                                    </div>
                                </div>
                                <button href="/become-seller" className="selectpackage-btn">Select Plan</button>
                                <ul className="icon-list">
                                    <li>
                                        Lorem ipsum dolor
                                    </li>
                                    <li>
                                        Lorem ipsum dolor
                                    </li>
                                    <li>
                                        Lorem ipsum dolor
                                    </li>
                                    <li>
                                        Lorem ipsum dolor
                                    </li>
                                    <li>
                                        Lorem ipsum dolor
                                    </li>
                                    <li>
                                        Lorem ipsum dolor
                                    </li>
                                    <li>
                                        Lorem ipsum dolor
                                    </li>
                                    <li>
                                        Lorem ipsum dolor
                                    </li>
                                    <li>
                                        Lorem ipsum dolor
                                    </li>
                                </ul>
                            </div>

                        </div>

                        <div className=" col-12  col-md-6 col-lg-3 px-20  mb-20">
                            <div className="packages-item-card">
                                <h6 className="text-center">Basic</h6>
                                <hr></hr>
                                <div className="prices discounted">
                                    <div className="original-price">
                                        <div className="main-price-element w-fit-content mx-auto">
                                            15.00
                                        </div>
                                    </div>
                                    <div className="discounted-price">
                                        <div className="main-price-element w-fit-content mx-auto">
                                            5.00
                                        </div>
                                    </div>
                                </div>
                                <button href="/become-seller" className="selectpackage-btn">Select Plan</button>
                                <ul className="icon-list">
                                    <li>
                                        Lorem ipsum dolor
                                    </li>
                                    <li>
                                        Lorem ipsum dolor
                                    </li>
                                    <li>
                                        Lorem ipsum dolor
                                    </li>
                                    <li>
                                        Lorem ipsum dolor
                                    </li>
                                    <li>
                                        Lorem ipsum dolor
                                    </li>
                                    <li>
                                        Lorem ipsum dolor
                                    </li>
                                    <li>
                                        Lorem ipsum dolor
                                    </li>
                                </ul>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>

    )
}

export default Package;